export default "__VITE_ASSET__CYoRC6a0__"